/*
User need:
- Expose public/terms/privacy-policy-en.md as a routed page (/terms/privacy-policy-en)
- Keep UI consistent with other Markdown pages

Key technical approach:
- Fetch and render markdown using react-markdown + remark-gfm
- Add route in App.js and navigation entry on HomePage
*/

import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const PrivacyPolicyEnPage = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/terms/privacy-policy-en.md')
      .then((response) => response.text())
      .then((text) => setContent(text))
      .catch((error) => console.error('Error loading privacy-policy-en:', error));
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <ReactMarkdown skipHtml remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      <footer style={{ marginTop: '50px', textAlign: 'center' }}>
        <p style={{ fontSize: '12px', color: '#999' }}>沪ICP备2025136834号-2</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicyEnPage;
